module.exports = __webpack_public_path__ + "static/media/logo.c99528f1.png";